import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getmyall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getmypage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const clientSearch = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/clientsearch' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getByGroupId = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getbygroupid/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getBindAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getbindall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const attentionAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/attentionall/' + params.vehicleInfoGroupId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changePicture = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/changepicture/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getAllSubscribe = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getallsubscribe' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getmyusergroupall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDirectlyUnderBindPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getdirectlyunderbindpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getGroupRecursiveAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getgrouprecursiveall/' + params.groupId + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientBindVehicleInfosPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getclientbindvehicleinfospage/' + params.userId + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getmyusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDirectlyUnderBindAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/getdirectlyunderbindall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const analyzeVehicleLicensePicture = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/analyzevehiclelicensepicture/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const inquireOperation = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/inquireoperation/' + params.registrationNum + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const bindVehicleInfosToUser = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/bindvehicleinfostouser/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changeBusinessUser = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/changebusinessuser/' + params.id + '/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const analyzeCertificatePicture = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/analyzecertificatepicture/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const unBindPositioningDeviceInfos = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/unbindpositioningdeviceinfos/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const unBindUserVehicleInfos = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/unbinduservehicleinfos/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const bindPositioningDeviceInfos = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicleinfo/bindpositioningdeviceinfos/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

